import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function TheEdge() {
  return <section className="py-24 md:py-32 bg-secondary border-t border-border" data-id="element-169">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-171">
          <ShieldCheck className="w-12 h-12 text-accent mx-auto mb-8" data-id="element-172" />
          <h2 className="text-xs text-accent tracking-[0.2em] uppercase mb-6" data-id="element-173">
            The Edge
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif text-text-light mb-8" data-id="element-174">
            This isn't just "students doing projects."
          </h3>
          <p className="text-lg text-text-muted mb-12" data-id="element-175">
            Every engagement is structured and quality-controlled by Critical
            Future.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-176">
            <div className="p-6 border border-border bg-primary" data-id="element-177">
              <h4 className="font-serif text-text-light mb-2" data-id="element-178">
                Defined Methodologies
              </h4>
            </div>
            <div className="p-6 border border-border bg-primary" data-id="element-179">
              <h4 className="font-serif text-text-light mb-2" data-id="element-180">
                Senior Oversight
              </h4>
            </div>
            <div className="p-6 border border-border bg-primary" data-id="element-181">
              <h4 className="font-serif text-text-light mb-2" data-id="element-182">
                Commercially Usable Outputs
              </h4>
            </div>
          </div>

          <div className="inline-block border-b border-accent pb-2" data-id="element-183">
            <p className="text-xl font-serif text-text-light italic" data-id="element-184">
              You get the speed and cost advantage of MBA talent with the rigour
              of a top-tier consulting firm.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}